import React from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export const VideoJS = (props:any) => {
    const videoRef = React.useRef<any>(null);
    const playerRef = React.useRef<any>(null);
    const {options, onReady} = props;

    React.useEffect(() => {
        if(typeof window === 'undefined') return;
       //  if(window && playerRef.current && videoRef.current) return;
        if (!playerRef.current) {
            const videoElement = document.createElement("video-js");
            videoElement.classList.add('vjs-big-play-centered');
            if(!videoRef.current) return;
            videoRef.current.appendChild(videoElement);

            const player = videojs(videoElement, options, () => {
                videojs.log('player is ready');
                onReady && onReady(player);
                playerRef.current = player?player:null;
            });
        } else {
            const player = playerRef.current;
            player.autoplay(options.autoplay);
            player.src(options.sources);
        }
    }, [onReady, options, videoRef]);

    React.useEffect(() => {
        const player = playerRef.current;
        return () => {
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [playerRef]);

    return (
        <div data-vjs-player>
            <div ref={videoRef} />
        </div>
    );
}

export default VideoJS;
